import React, { useEffect, useState } from 'react';
import { useIsFirstRender } from '../../../_shared/react-hooks';
import './style.scss';

const Toggle = ({ label, defaultPosition, onChange, rightLabel, leftLabel }: IToggle) => {
  const [position, setPosition] = useState(defaultPosition || 'right');

  const isFirstRender = useIsFirstRender();

  useEffect(() => {
    if (!isFirstRender && position !== defaultPosition) {
      if (defaultPosition) setPosition(defaultPosition);
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultPosition]);

  return (
    <div className="toggle-wrapper">
      {leftLabel && <div className="side-label">{leftLabel}</div>}
      <label
        className="toggle-container"
        tabIndex={0}
        onKeyDown={(e: React.KeyboardEvent) => {
          // Keyboard accessible
          if (['Enter', ' '].includes(e.key)) {
            const toggle = e.currentTarget;
            (toggle as HTMLElement).click();
          }
        }}
      >
        <input
          type="checkbox"
          data-testid={`${
            position === 'left' ? 'size-guide-measurementSystem-inches' : 'size-guide-measurementSystem-cm'
          }`} // Send the future state of the toggle to Heap
          data-position={position}
          aria-label={label ? label : ''}
          onClick={() => {
            setPosition((prev) => {
              const next = prev === 'right' ? 'left' : 'right';
              onChange?.(next);
              return next;
            });
          }}
        />
        <span className="toggle-slider" />
      </label>
      {rightLabel && <div className="side-label">{rightLabel}</div>}
    </div>
  );
};

export default Toggle;

interface IToggle {
  label?: string;
  defaultPosition?: 'right' | 'left';
  onChange?: (position: string) => void;
  leftLabel?: string;
  rightLabel?: string;
}
